export const HANDLE_SERVER_EXCEPTION = 'HANDLE_SERVER_EXCEPTION';

function requestHandleServerException(exception) {
  return {
    type: HANDLE_SERVER_EXCEPTION,
    ...exception
  };
}

export function handleServerException(exception, callbackActionCreator, showAlert = true) {
  return (dispatch) => {
    if (!exception || !exception.data) {
      exception.data = {
        code: 500,
        message: "Something's not quite right. Please try again or speak to your designated contact."
      };
    }

    if (exception && exception.status === 403 && exception.data.code === 498) {
      return null;
    }

    const errorData = exception.data.error ? exception.data.error : exception.data;

    if (exception.data.Error) {
      errorData.code = exception.data.Error.Code;
      errorData.message = exception.data.Error.Message;
    }

    if (callbackActionCreator && typeof callbackActionCreator === 'function') {
      dispatch(callbackActionCreator(errorData));
    }

    if (showAlert) {
      return dispatch(requestHandleServerException(errorData));
    }
    return null;
  };
}
